export var Name = 'update-offer-item';
export var UpdateOfferItemEvent = Name;